import React, { useState, useEffect } from "react";
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Grid,
  Typography,
  Skeleton,
} from "@mui/material";
import { Verified } from "@mui/icons-material";
import { formatDistanceToNow, parseISO } from "date-fns";
import { useParams } from "react-router-dom";
import logo from "../assets/browse-job/logo.png";
import icon9 from "../assets/jobs-icon/9.svg";
import xicon from "../assets/jobs-icon/x.svg";
import Avatar_ from "./Avatar_";
import CustomAvatarGroup from "./CustomAvatarGroup";
import ShareButton from "./ShareModal";
import API from "../api";

const JobDetailsCard = ({ data, handleApplyClick }) => {
  const param = useParams();
  const [states, setStates] = useState();
  const budgetData = [
    {
      icon: "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/9.svg",
      title: "Airfare",
      message: "Is airfare covered by this client?",
      value: Number(data?.airfare_covered),
    },
    {
      icon: "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/hotel.svg",
      title: "Hotel",
      message: "Does this client offer hotel accommodation?",
      value: Number(data?.hotel_accommodation_covered),
    },
    {
      icon: "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/car.svg",
      title: "Car",
      message: "Does this client provide car rental?",
      value: Number(data?.car_rental_covered),
    },
    {
      icon: "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/tolls.svg",
      title: "Tolls",
      message: "Does this client cover toll expenses?",
      value: Number(data?.toll_expense_covered),
    },
    {
      icon: "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/logged-miles.svg",
      title: "Logged miles",
      message: "Does the client cover mileage reimbursement?",
      value: Number(data?.logged_miles_covered),
    },
    {
      icon: "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/gas.svg",
      title: "Gas",
      message: "Does this client cover gas or fuel expenses?",
      value: Number(data?.gas_expense_covered),
    },
    {
      icon: "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/parking-fees.svg",
      title: "Parking fee",
      message: "Does this client cover parking fee expenses?",
      value: Number(data?.parking_fee_covered),
    },
    {
      icon: "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/overbudget.svg",
      title: "Over Budget Travel",
      message: "Will clients approve overbudget travel costs?",
      value: Number(data?.overbudget_travel_covered),
    },
  ];

  const getTimeAgo = (updatedAt) => {
    if (!updatedAt) return "";
    const updatedDate = parseISO(updatedAt);
    return `Posted ${formatDistanceToNow(updatedDate, { addSuffix: true })}`;
  };
  const getLocations = async () => {
    try {
      // const resp = await API.get("/api/get-states/231");
      const resp = await API.get("/api/get-states/231");

      if (resp?.data?.success) {
        setStates(resp?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getLocations();
  }, []);
  if (data?.length <= 0) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: "15px",
            my: { xs: 2, sm: 3 },
            p: { xs: "20px", sm: "35px", xl: "50px" },
            border: "1px solid #EBEDF0",
            maxWidth: "1620px",
            mx: "20px",
            width: "100%",
          }}
        >
          {/* Header Section */}
          <Grid container spacing={{ xs: 2, sm: 3 }}>
            {/* Logo */}
            <Grid item xs={12} sm={2} md={1.3}>
              <Skeleton variant="rectangular" width={134} height={134} />
            </Grid>

            {/* Job Details */}
            <Grid item xs={12} sm={10} md={10.7}>
              <Skeleton variant="text" width="60%" height={32} />
              <Skeleton variant="text" width="80%" height={24} />
              <Skeleton variant="text" width="40%" height={18} />
            </Grid>
          </Grid>

          {/* Description Section */}
          <Grid container spacing={2} sx={{ mt: { xs: 2, sm: 3 } }}>
            <Grid item xs={12} sm={9}>
              <Skeleton variant="text" width="30%" height={32} />
              <Skeleton variant="rectangular" width="100%" height={150} />
            </Grid>
          </Grid>

          {/* Facilities Section */}
          <Skeleton variant="text" width="40%" height={32} />
          <Grid container spacing={2} sx={{ mt: { xs: 2, sm: 3 } }}>
            <Grid item xs={12} sm={6}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          bgcolor: "white",
          // borderRadius: "24px",
          my: { xs: 2, sm: 3 },
          p: { xs: "32px", sm: "40px", xl: "48px" },
          // border: "1px solid #EBEDF0",
          maxWidth: "1620px",
          mx: "20px",
          width: "100%",
          // boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Content Sections */}
        <Grid container spacing={{ xs: 3, sm: 4 }} sx={{}}>
          {/* We are looking for... Section */}
          <Grid item xs={12} md={8}>
            <Typography
              sx={{
                fontSize: "32px",
                fontWeight: 500,
                color: "#2F4F4F",
                mb: 2,
                fontFamily: "Inter, sans-serif",
              }}
            >
              We are looking for...
            </Typography>
            {data?.description !== "null" &&
              data?.description !== "<p>null</p>" && (
                <Typography
                  sx={{
                    fontSize: { xs: "16px", xl: "18px" },
                    fontWeight: 400,
                    color: "#2F4F4F",
                    lineHeight: { xs: "24px", xl: "28px" },
                    mb: 3,
                  }}
                >
                  <span
                    dangerouslySetInnerHTML={{ __html: data?.description }}
                  ></span>
                </Typography>
              )}

            {/* Skills Required */}
            {/* <Typography
                sx={{
                  fontSize: '20px',
                  fontWeight: 600,
                  color: "#1F2937",
                  mb: 2.5,
                  fontFamily: "Inter, sans-serif",
                }}
            >
              Skills required
            </Typography> */}
            {/* <Box sx={{ pl: 2 }}>
              <Typography
                sx={{
                  fontSize: { xs: "16px", xl: "18px" },
                  fontWeight: 400,
                  color: "#2F4F4F",
                  lineHeight: { xs: "24px", xl: "28px" },
                  mb: 1,
                }}
              >
                • Board-certified in Cardiology
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "16px", xl: "18px" },
                  fontWeight: 400,
                  color: "#2F4F4F",
                  lineHeight: { xs: "24px", xl: "28px" },
                  mb: 1,
                }}
              >
                • Excellent diagnostic and surgical skills
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "16px", xl: "18px" },
                  fontWeight: 400,
                  color: "#2F4F4F",
                  lineHeight: { xs: "24px", xl: "28px" },
                }}
              >
                • Strong communication and patient care abilities
              </Typography>
            </Box> */}
          </Grid>

          {/* Job Requirements Section - Separate Card */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                bgcolor: "#F8F9FA",
                borderRadius: "12px",
                p: 3,
                height: "fit-content",
              }}
            >
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "#1F2937",
                  mb: 2.5,
                  fontFamily: "Inter, sans-serif",
                }}
              >
                Job Requirements
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* Provider Roles */}

                {data?.provider_roles?.length > 0 && (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#6B7280",
                      lineHeight: "20px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#1F2937",
                        minWidth: "140px",
                        flexShrink: 0,
                      }}
                    >
                      Provider Roles:
                    </span>
                    {data?.provider_roles?.map((role) => role.name).join(", ")}
                  </Typography>
                )}
                {data?.board_eligible || data?.board_certified ? (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#6B7280",
                      lineHeight: "20px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#1F2937",
                        minWidth: "140px",
                        flexShrink: 0,
                      }}
                    >
                      Board certification/eligibility:
                    </span>
                    {data?.board_certified ? "Board Certified (BC)" : ""},
                    {data?.board_eligible ? "Board Eligible (BE) " : ""}
                  </Typography>
                ) : (
                  ""
                )}

                {/* Experience required */}
                {data?.experience_required ? (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#6B7280",
                      lineHeight: "20px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#1F2937",
                        minWidth: "140px",
                        flexShrink: 0,
                      }}
                    >
                      Experience required: &nbsp;
                    </span>
                    {data?.experience_required}
                  </Typography>
                ) : (
                  ""
                )}

                {/* Location of Site */}
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#6B7280",
                    lineHeight: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#1F2937",
                      minWidth: "140px",
                      flexShrink: 0,
                    }}
                  >
                    Location of Site:
                  </span>{" "}
                  {data?.client_city}
                </Typography>

                {/* State license */}
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#6B7280",
                    lineHeight: "20px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#1F2937",
                      minWidth: "140px",
                      flexShrink: 0,
                    }}
                  >
                    State license: &nbsp;
                  </span>
                  {
                    states?.find(
                      (state) => state?.id === data?.state_license_id
                    )?.name
                  }
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Facilities Section */}
        <Box sx={{ mt: { xs: 5, xl: 6 } }}>
          <Typography
            sx={{
              mb: { xs: 3, xl: 4 },
              fontWeight: 500,
              fontSize: "32px",
              color: "#2F4F4F",
              fontFamily: "Inter, sans-serif",
            }}
          >
            Facilities
          </Typography>

          <Grid container spacing={2}>
            {budgetData
              .filter((item) => item.value)
              .map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: { xs: 3, xl: 4 },
                      borderRadius: "12px",
                      border: "1px solid #E7EAF3",
                      bgcolor: "#F8F9FA",
                      height: { xs: "auto", sm: "90px", xl: "100px" },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        component="img"
                        src={item.icon}
                        alt={item.title}
                        sx={{
                          width: { xs: "32px", sm: "40px", xl: "48px" },
                          height: { xs: "32px", sm: "40px", xl: "48px" },
                        }}
                      />
                      <Box>
                        <Typography
                          sx={{
                            fontSize: { xs: "16px", xl: "18px" },
                            fontWeight: 500,
                            color: "#2F4F4F",
                            mb: 0.5,
                          }}
                        >
                          {item.message}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        component="img"
                        src={
                          item.value
                            ? "https://projects.tangiblethemes.com/Shglocums/wp-content/uploads/2024/12/check2-circle.svg"
                            : xicon
                        }
                        alt={item.value ? "Yes" : "No"}
                        sx={{
                          width: { xs: "20px", xl: "24px" },
                          height: { xs: "20px", xl: "24px" },
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: 500,
                          fontFamily: "Inter, sans-serif",
                          color: item.value ? "#343A40" : "#EF4444",
                        }}
                      >
                        {item.value ? "Yes" : "No"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default JobDetailsCard;
